<template>

  <v-select 
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
export default {
  name: 'SelectVideoform',
  props: [
    'value',
    'placeholder'
  ],
  data () {
    return {
      'videoforms': []
    }
  },
  computed: {
    valueId () {
      return this.value && this.value._id ? this.value._id : this.value
    },
    options () {
      return this.videoforms.map((val) => {
        return {
          label: val.name,
          value: val._id,
          object: val
        }
      })
    },
    selected () {
      return this.options.find((val) => {
        return val.value === this.valueId
      })
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getVideoforms', {sort: 'name', limit: 2000})
      .then((result) => {
        this.videoforms = result.docs
      })
    },
    change (val) {
      const value = val ? val.value : null

      if (value !== this.valueId) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectVideoform.vue